import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { PopupFieldData } from "src/app/features/designer-studio/edit-pdf-doc/models/doc.model";

@Component({
  selector: "app-screen-label",
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  @Input() initOptions: PopupFieldData;
  
}